<template>
  <EditCard
    ref="editCard"
    :visible.sync="dialogVisible"
    :card="editingCard"
    :collections="collections"
    :preselectedCollectionId="preselectedCollectionId"
    @saved="handleSaved"
    @close="handleClose"
  />
</template>

<script>
import EditCard from './EditCard.vue'

export default {
  name: 'AddKnowitDialog',
  components: {
    EditCard
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    card: {
      type: Object,
      default: () => null
    },
    collections: {
      type: Array,
      default: () => []
    },
    preselectedCollectionId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {
    editingCard() {
      return this.card
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    handleSaved(card) {
      // Re-emit for parent pages to update UI without reload
      console.log('[AddKnowitDialog] received saved from EditCard:', card)
      this.$emit('saved', card)
      console.log('[AddKnowitDialog] emitted saved to parent')
    },
    
    resetSavingState() {
      // Reset the EditCard's saving state
      if (this.$refs.editCard) {
        this.$refs.editCard.resetSavingState()
      }
    },
    
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>